export default "__VITE_ASSET__BqLegF49__"